import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DateRange } from '@angular/material/datepicker';
import { FabricService } from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'ticketing-resources';

@Injectable({
  providedIn: 'root'
})
export class TicketingService {

  constructor(private fabricService: FabricService) {

  }

  getSecurityTickets(dateRange: DateRange<Date>): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_security_stats', {
      startAt: dateRange?.start?.toISOString(),
      endAt: dateRange?.end?.toISOString(),
      }
    );
  }

  getSupportTickets(dateRange: DateRange<Date>): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_support_stats', {
      startAt: dateRange.start.toISOString(),
      endAt: dateRange.end.toISOString(),
    });
  }

  getTicketsOverTime(dateRange: DateRange<Date>): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_incident_stats', {
      startAt: dateRange.start.toISOString(),
      endAt: dateRange.end.toISOString(),
    });
  }
}
